import React, { useState } from "react";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Cabins } from "@/components/Cabins";
import { BookingForm } from "@/components/BookingForm";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";

function App() {
  const [selectedCabinId, setSelectedCabinId] = useState("domo-01");

  const handleSelectCabin = (id) => {
    setSelectedCabinId(id);
    // Smooth-scroll to booking
    setTimeout(() => {
      const el = document.getElementById("reserva");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  };

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Cabins onSelectCabin={handleSelectCabin} />
        <BookingForm
          selectedCabinId={selectedCabinId}
          setSelectedCabinId={setSelectedCabinId}
        />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;
